import { render } from "./SideMenu.vue?vue&type=template&id=38f6b65b&ts=true"
import script from "./SideMenu.vue?vue&type=script&lang=ts"
export * from "./SideMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__